import React from "react";
import InfoIcon from "../../../../assets/icons/info";
import GOINestedTitles from ".";
import useWidth from "../../../../hooks/useWidth";

/**
 * A wrapper component for GOINestedTitles that manages the display of nested header titles based on the available width.
 * items - The items to be passed to the GOINestedTitles component.
 * data - The data object containing the id and attrDescription for the tooltip.
 */
function GOINestedTitlesWrapper({ items, data }) {
  // ref keeps track of div width because we need to show/hide header titles according to the width
  const ref = React.useRef(null);
  // outerWidth is used to determine if the nested titles should be displayed or hidden
  const outerWidth = useWidth(ref);

  return (
    <div ref={ref} className="w-100">
      <div
        id={`nested-header-wrapper`}
        className="goi-header-section-name-wrapper"
        key={data.id}
      >
        {/* GOINestedTitles component displays the nested titles */}
        <GOINestedTitles outerWidth={outerWidth} items={items} />
        {/* Tooltip component that displays additional information */}
        <div className="goi-tooltip">
          <InfoIcon />
          <span className="goi-tooltiptext">{data.attrDescription}</span>
        </div>
      </div>
    </div>
  );
}

export default GOINestedTitlesWrapper;
